// extracted by mini-css-extract-plugin
module.exports = {"footer":"style__footer__2SNqh","languages":"style__languages__L3Dbm"};